import { useState } from "react";
import { PRECISION } from "../precision";

export const useDecimalInput = (initial = "") => {
  const [input, setInput] = useState(initial);
  const [value, setValue] = useState(null);

  const onChange = (e) => {
    const v = e.target.value;

    if (/^\d*\.?\d*$/.test(v)) {
      setInput(v);
    }
  };

  const onBlur = () => {
    if (input === "") {
      setValue(null);
      return;
    }

    const n = Number(input);
    if (!Number.isFinite(n)) return;

    const fixed = Number(n.toFixed(PRECISION));
    setValue(fixed);
    setInput(fixed.toFixed(PRECISION));
  };

  return {
    input,
    value,
    bind: {
      value: input,
      onChange,
      onBlur,
    },
    setFromBackend: (num) => {
      if (typeof num === "number") {
        setValue(num);
        setInput(num.toFixed(PRECISION));
      }
    },
    reset: () => {
      setInput("");
      setValue(null);
    },
  };
};
